import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { onboardingAnswer, onboardingData, onboardingFlow } from "../redux/actions/chatAiActions";
import Toast from "./assetLibComponents/shared/Toast";
import Reading from "../assets/zoiReading.gif";
import Looking from "../assets/zoiLooking.gif";
import Jump from "../assets/zoiJump.gif";
import Industry from "../assets/indwork.svg";
import OrgSize from "../assets/Organization-sizeWork.svg";
import Chat from "../assets/ChatWork.svg";
import Crm from "../assets/CRMWork.svg";
import PassImg from "../assets/PasswordWork.svg";
import { useSelector } from "react-redux";
import SingleSelectDropdown from "./SimpleSelectInput";
import * as Icon from "react-bootstrap-icons";


const Onboarding = (props) => {
  const [name, setName] = useState("");
  const [lName, setLName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [isPassFocused, setIsPassFocused] = useState(false);
  const [isCompFocused, setIsCompFocused] = useState(false);
  const [passwordCheck, setPasswordCheck] = useState(false);
  const [counter, setCounter] = useState(0);
  const [selectedItem, setSelectedItem] = useState("");
  const [selectedID, setSelectedID] = useState("");
  const [lastOptions, setlastOptions] = useState("");
  const [othersShow, setOthersShow] = useState(false);
  const [industrySelected, setIndustrySelected] = useState("Information Technology");
  const [inputShow, setInputShow] = useState(false);
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const oData = useSelector((state) => state.chatAi.onboardingData);
  const uData = JSON.parse(localStorage.getItem("userData"));
  const [showPassword, setShowPassword] = useState("");


  const imgCounter = [Industry,OrgSize,Crm,Chat]


  const handleSelectedItem = (option,id) =>{
    setSelectedItem(option)
    setSelectedID(id)
  }
  
  const handleNext = () => {
    if(selectedItem?.length > 0){
      setCounter(counter+1)
      setOthersShow(false);
      if(oData?.[counter]?.answer !== selectedItem){
        dispatch(onboardingAnswer(props.authToken,selectedID,selectedItem,uData));
      }
      setSelectedItem("")
    }else{
      Toast("Please select any option", "E");
    }
  }
  const handleLastQuestion = () => {
    if(selectedItem?.length > 0){
      setOthersShow(false);
      if(oData?.[counter]?.answer !== selectedItem){
        dispatch(onboardingAnswer(props.authToken,selectedID,selectedItem,uData));
      }
      setSelectedItem("")
    }else{
      Toast("Please select any option", "E");
    }
  }

  const handleBack = () => {
    setCounter(prev=>prev-1)
    setOthersShow(false);
    setSelectedItem("")
    setlastOptions("")
  }
  const handleSubmit = () => {
    
      const uData = JSON.parse(localStorage.getItem("userData"));
      if(name !== "" || password !== "" || rePassword !== "" || industrySelected !== "" || industrySelected !== "Others" ){
        if(passwordCheck === false){
            dispatch(onboardingFlow(props.authToken, name,password, rePassword,uData,companyName,lName,industrySelected));
        }
      }else{
        Toast("Please fill all the fields", "E");
      }
  }

  useEffect(()=>{
    dispatch(onboardingData(props.authToken));
  },[])

  useEffect(()=>{
    if(oData?.[counter]?.answer?.length > 0){
      setSelectedItem(oData?.[counter]?.answer);
      setSelectedID(oData?.[counter]?.id)
    }
  },[counter])

  useEffect(()=>{
    if(uData?.stripeData?.stripe_day_count === 0){
      navigate(`/404`);
    }
    if(uData?.set_question === true){
      if(uData?.data?.intent){
        navigate(`/Intel/Setting`);
      }else{
        navigate(`/Chat-Ai`)      
    }
    }
  },[])

  return (
    <div className="flex h-screen flex-col bg-[#F3F4F6]">
     <h2 className="ms-10 mt-10 text-left text-[#49BCD2] font-[900] text-3xl">Zoi</h2>
      {uData?.set_password !== true &&
      <div className="mx-4 sm:mr-16 sm:ml-40 mt-[1rem] grid gap-10 grid-cols-10">
<div className="col-span-10 sm:col-span-5  flex flex-col">
        <div className="text-3xl lg:text-3xl font-[500] text-[#49BCD2]">Let’s set up</div>
        <div className="text-3xl lg:text-3xl font-[500] text-[#49BCD2]">your account!</div>
        <div className="mt-5">
      {isFocused && <div className="max-sm:hidden flex slide-in-left relative mb-3 ">
            <img src={Reading} className="absolute b-[10] w-24 h-24 left-[-19%] top-[-25%]"/>
          { <p className="font-[700] text-sm text-white bg-[var(--brand-primary)] px-3 rounded-xl py-2.5">What should I refer to you as? Batman?</p>}
          </div>}
          {isFocused && <p className="sm:hidden slide-in-left mb-2 font-[700] text-sm text-white bg-[var(--brand-primary)] px-3 rounded-xl py-2.5">What should I refer to you as? Batman?</p>}
          
          <div className="flex sm:mr-[30%]">
          <div className="bg-white w-full rounded-md px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:[var(--brand-primary)]">
            <label
              htmlFor="name"
              className="block text-xs font-medium text-gray-900"
            >
               First Name
            </label>
            <input
              onFocus={()=>{setIsFocused(true);}}
              onBlur={()=>{setIsFocused(false);}}
              autoComplete="off"
              type="text"
              name="name"
              id="firstname"
              className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
              placeholder="Enter"
              onChange={(e)=>{setName(e.target.value)}}
            />
          </div>
          <div className="bg-white w-full ml-2 rounded-md px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:[var(--brand-primary)]">
            <label
              htmlFor="name"
              className="block text-xs font-medium text-gray-900"
            >
               Last Name
            </label>
            <input
            //   onFocus={()=>{setIsFocused(true);}}
              autoComplete="off"
              type="text"
              name="name"
              id="lastname"
              className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
              placeholder="Enter"
              onChange={(e)=>{setLName(e.target.value)}}
            />
          </div>
          </div>
          {isCompFocused && <div className="max-sm:hidden flex slide-in-left relative my-3 ">
            <img src={Jump} className="absolute b-[10] w-24 h-24 left-[-19%] top-[-25%]"/>
          { <p className="font-[700] text-sm text-white bg-[var(--brand-primary)] px-3 rounded-xl py-2.5">We'll do great things together!</p>}
          </div>}
          {isCompFocused && <p className="sm:hidden slide-in-left my-2 font-[700] text-sm text-white bg-[var(--brand-primary)] px-3 rounded-xl py-2.5">We'll do great things together!</p>}

          <div className="bg-white mt-3 sm:mr-[30%] rounded-md px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:[var(--brand-primary)]">
            <label
              htmlFor="name"
              className="block text-xs font-medium text-gray-900"
            >
               Company Name
            </label>
            <input
             onFocus={()=>{setIsCompFocused(true);}}
             onBlur={()=>{setIsCompFocused(false);}}
              autoComplete="off"
              type="text"
              name="name"
              id="companyname"
              className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
              placeholder="Enter"
              onChange={(e)=>{setCompanyName(e.target.value)}}
            />
          </div>
        </div>
        {oData && <div>
        <div className="rounded-md sm:mr-[30%] px-3 pb-1.5 mt-3 pt-2.5 ring-1 ring-inset bg-white ring-gray-300">
                    <label
                      htmlFor="colorMode"
                      className="block text-xs font-medium text-gray-800"
                    >
                      Industry
                    </label>
          <SingleSelectDropdown people={oData[0]?.options}
                      selected={industrySelected}
                      setSelected={setIndustrySelected}
                      setInput={setInputShow}
                      inputShow={inputShow}
                      />
                      </div>
        </div>}
        <div className="mt-3">
        {isPassFocused && <div className="max-sm:hidden flex slide-in-left relative mb-3 ">
            <img src={Looking} className="absolute b-[10] w-24 h-24 left-[-19%] top-[-25%]"/>
          { <p className="font-[700] text-sm text-white bg-[var(--brand-primary)] px-3 rounded-xl py-2.5">Go on I am not looking!</p>}
          </div>}
          {isPassFocused && <p className="sm:hidden slide-in-left mb-2 font-[700] text-sm text-white bg-[var(--brand-primary)] px-3 rounded-xl py-2.5">Go on I am not looking!</p>}
          <div className="bg-white relative sm:mr-[30%] rounded-md px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:[var(--brand-primary)]">
            <label
              htmlFor="name"
              className="block text-xs font-medium text-gray-900"
            >
              Set up a password
            </label>
            <input
             onFocus={()=>{setIsPassFocused(true);}}
             onBlur={()=>{setIsPassFocused(false);}}
             onChange={(e) => {
                const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
                if (regex.test(e.target.value) || e.target.value.length < 1 || e.target.value.length === null ) {
                    setPasswordCheck(false);
                } else {
                    setPasswordCheck(true);
                }
                setPassword(e.target.value)
              }}
             autoComplete="off"
              type={showPassword !== true ? "password":"text"}
              name="name"
              id="password"
              className="w-full pr-[35px] border-0 p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
              placeholder="Enter"
            //   onChange={(e)=>{setPassword(e.target.value)}}
            />
            { showPassword === true ? <Icon.Eye onClick={() => { setShowPassword(false); }} className="cursor-pointer absolute text-lg text-[var(--brand-primary)] right-[20px] bottom-[18%]"/> 
                :
                <Icon.EyeSlash onClick={() => { setShowPassword(true); }} className="cursor-pointer absolute text-lg text-gray-500 right-[20px] bottom-[18%]" />
            }
          </div>
          <div className="bg-white sm:mr-[30%]  mt-3 rounded-md px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:[var(--brand-primary)]">
            <label
              htmlFor="name"
              className="block text-xs font-medium text-gray-900"
            >
              Re Enter the password
            </label>
            <input
              type="password"
              autoComplete="off"
              name="name"
              id="repassword"
              className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
              placeholder="Enter"
              onChange={(e)=>{setRePassword(e.target.value)}}

            />
          </div>
          
          {passwordCheck === true && <p  className="ml-1 mt-2 text-red-700 text-[10px]">Password must be at least 8 characters long and include at least one letter, one number, and one special character.</p>}    
        </div>
          <div onClick={handleSubmit} className="cursor-pointer mr-auto flex bg-[#49BCD2] text-white py-1 px-2 rounded-md my-6 font-[700]">Submit</div>
      </div>
      <div className="col-span-5 sm:mr-24 max-sm:hidden h-[60vh]">
          <img src={PassImg} className="mx-auto h-[90%]"/>
        </div>
      </div>
       }
    {/* {uData?.set_password === true && <div className="mx-16 mt-[4rem] grid gap-10 grid-cols-10">
        <div className="col-span-10 sm:col-span-5  flex flex-col">
          <div className="text-3xl font-[500] leading-10 w-[90%]">
           {oData?.[counter]?.question}
          </div>
          {counter < 3 && <div className="mt-10 flex flex-wrap w-[80%]">
            {oData?.[counter]?.options?.map((item)=>(
            <div onClick={()=>handleSelectedItem(item,oData?.[counter]?.id)} className={`border border-[#49BCD2] font-[500] rounded-xl py-1 px-2 cursor-pointer flex-nowrap ${selectedItem === item ? "bg-[#49BCD2] text-white":"text-[#49BCD2] bg-white"} hover:bg-[#49BCD2] hover:text-white  mr-2 my-2 `}>{item}</div>
            ))}
             <div onClick={()=>{setOthersShow(!othersShow);setSelectedID(oData?.[counter]?.id)}} className={`border border-[#49BCD2] font-[500] rounded-xl py-1 px-2 cursor-pointer flex-nowrap ${!oData?.[counter]?.options?.includes(selectedItem) && oData?.[counter]?.answer?.length > 0 ? "bg-[#49BCD2] text-white":"text-[#49BCD2] bg-white"} hover:bg-[#49BCD2] hover:text-white  mr-2 my-2 `}>Others</div>
          </div>}
          {counter > 2 && lastOptions === "Yes" && <div className="my-5 text-gray-700">Select one of the following chat application :</div>}
          {counter > 2 &&<div className="flex flex-wrap w-[80%]">
            {oData?.[counter]?.options?.map((item)=>(lastOptions === "Yes" &&
            <div onClick={()=>handleSelectedItem(item,oData?.[counter]?.id)} className={`border border-[#49BCD2] font-[500] rounded-xl py-1 px-2 cursor-pointer flex-nowrap ${selectedItem === item ? "bg-[#49BCD2] text-white":"text-[#49BCD2] bg-white"} hover:bg-[#49BCD2] hover:text-white  mr-2 my-2 `}>{item}</div>
            ))}
            {lastOptions === "Yes" && <div onClick={()=>{setOthersShow(!othersShow);}} className={`border border-[#49BCD2] font-[500] rounded-xl py-1 px-2 cursor-pointer flex-nowrap ${!oData?.[counter]?.options?.includes(selectedItem) && oData?.[counter]?.answer?.length > 0 ? "bg-[#49BCD2] text-white":"text-[#49BCD2] bg-white"} hover:bg-[#49BCD2] hover:text-white  mr-2 my-2 `}>Others</div>}
            {lastOptions !== "Yes" && <div onClick={()=>{setlastOptions("Yes");}} className={`mt-10 border border-[#49BCD2] font-[500] rounded-xl py-1 px-2 cursor-pointer flex-nowrap ${lastOptions === "Yes" ? "bg-[#49BCD2] text-white":"text-[#49BCD2] bg-white"} hover:bg-[#49BCD2] hover:text-white  mr-2 my-2 `}>Yes</div>}
            {lastOptions !== "Yes" &&<div onClick={()=>{setlastOptions("No");setSelectedItem("No");setSelectedID(4)}} className={`mt-10 border border-[#49BCD2] font-[500] rounded-xl py-1 px-2 cursor-pointer flex-nowrap ${lastOptions === "No" ? "bg-[#49BCD2] text-white":"text-[#49BCD2] bg-white"} hover:bg-[#49BCD2] hover:text-white  mr-2 my-2 `}>No</div>}
          </div>}
          {othersShow && <div className="mt-4 bg-white rounded-md px-3 pb-1.5 pt-2.5 shadow-sm ring-1 ring-inset ring-[#49BCD2] focus-within:ring-2 focus-within:[var(--brand-primary)] w-[60%]">
            <input
              autoComplete="off"
              type="text"
              name="Others"
              id="Others"
              value={selectedItem}
              className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
              placeholder={oData?.[counter]?.placeholder}
              onChange={(e)=>{setSelectedItem(e.target.value);}}
            />
          </div>}
          <div className="flex mt-8">
            {counter > 0 && <div onClick={handleBack} className="cursor-pointer bg-[#49BCD2] text-white py-1 px-2 rounded-md mr-6 my-6 font-[700]">Back</div>}
            {oData?.length - 1 !== counter && <div onClick={handleNext} className="cursor-pointer bg-[#49BCD2] text-white py-1 px-2 rounded-md my-6 font-[700]">Next</div>}
            {oData?.length - 1 === counter  && <div onClick={handleLastQuestion} className="cursor-pointer bg-[#49BCD2] text-white py-1 px-2 rounded-md my-6 font-[700]">Submit</div>}
          </div>
        </div>
        <div className="col-span-5 max-sm:hidden h-[60vh]">
          <img src={imgCounter[counter]} className="mx-auto h-[90%]"/>
        </div>
      </div>} */}
    </div>
  );
};

export default Onboarding;
